import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-200/70 pt-16 md:pt-20 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="relative">
          <div className="absolute -top-8 -left-4 w-6 h-12 bg-foreground-900/5 rounded-sm rotate-12 hidden md:block"></div>
          <div className="absolute -top-8 -right-4 w-6 h-12 bg-foreground-900/5 rounded-sm -rotate-12 hidden md:block"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-xl font-bold text-foreground-900">
                CSSBuy<span className="text-primary-500">Spreadsheet</span>
              </span>
              <p className="text-xs text-foreground-600 mt-3 leading-relaxed max-w-xs">
                A principal plataforma em português para encontrar links CSSBuy
                confiáveis, planilhas atualizadas e guias completos para comprar
                da China com segurança.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Guias Essenciais
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/artigo/cssbuy-sheet-guia-completo" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guia Completo CSSBuy</Link></li>
                <li><Link to="/artigo/como-usar-cssbuy-iniciantes" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Como Usar CSSBuy</Link></li>
                <li><Link to="/artigo/seguranca-cssbuy-guia" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guia de Segurança</Link></li>
                <li><Link to="/artigo/qc-cssbuy-guia-definitivo" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guia de QC</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Comparativos
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/artigo/cssbuy-vs-pandabuy" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">CSSBuy vs PandaBuy</Link></li>
                <li><Link to="/artigo/melhores-agentes-china-2026" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Melhores Agentes</Link></li>
                <li><Link to="/artigo/cssbuy-frete-brasil-guia" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Frete Brasil</Link></li>
                <li><Link to="/artigo/cssbuy-haul-montagem-guia" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Montar Haul</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Marcas e Links
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/artigo/melhores-links-nike-cssbuy" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Links Nike</Link></li>
                <li><Link to="/artigo/cssbuy-tenis-melhores-links" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Melhores Tênis</Link></li>
                <li><Link to="/artigo/marcas-cssbuy-yupoo-2026" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Marcas e Yupoo</Link></li>
                <li><Link to="/artigo/cssbuy-portugal-compras" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guia Portugal</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Links Úteis
              </h4>
              <ul className="space-y-2.5">
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">CSSBuy Sheet</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">kaspreadsheet.com</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Contato</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
              <span>&copy; 2026 CSSBuySpreadsheet</span>
              <span className="text-foreground-400">|</span>
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">Início</Link>
              <span className="text-foreground-400">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors whitespace-nowrap">Privacidade</a>
              <span className="text-foreground-400">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors whitespace-nowrap">Termos</a>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}